module.exports = __webpack_public_path__ + "img/qbert_questions_p21.ba965cdd.jpg";